<template>
  <tr class="expert-tool-history__comparison-row">
    <td
      class="expert-tool-history__comparison-row-label"
    >{{ label }}: {{ date }}</td>
    <td
      v-for="(column, i) in columns"
      :key="`${column.name}-${i}`"
    >
      <div class="expert-tool__table-cell-content" v-if="prescription">
        <v-tooltip
          bottom
          v-if="prescription[`${column.name}Label`]"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="expert-tool__table-cell-icon"
              v-bind="attrs"
              v-on="on"
            >{{ column.icon }}</v-icon>
          </template>
          <span>
            {{ $ucfirst($t(`expertTool.columnNames.${column.name}`)) }}
          </span>
        </v-tooltip>
        <span
        >{{ prescription[`${column.name}Label`] || '' }}</span>
      </div>
    </td>
  </tr>
</template>

<script>
/**
 * Component HistoryComparisonRow.vue
 *
 * @module HistoryComparisonRow
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/ExpertTool/History/HistoryComparisonRow.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: 'HistoryComparisonRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: () => '',
    },
    prescription: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns: [
        {
          name: 'intensity',
          icon: 'mdi-emoticon-dead-outline'
        },
        {
          name: 'frequency',
          icon: 'mdi-chart-line',
        },
        {
          name: 'sessionDuration',
          icon: 'mdi-timer-outline',
        },
        {
          name: 'programDuration',
          icon: 'mdi-calendar-month-outline',
        },
        {
          name: 'strengthTraining',
          icon: 'mdi-dumbbell',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.expert-tool-history__comparison-row td {
  padding: 12px 16px;
}
</style>
